module.exports = __webpack_public_path__ + "static/icon-loan.7b997f73.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-loan.png
// module id = 289
// module chunks = 2